<template>
  <div class="marges-page" v-show="image != null">
    <div class="panneau" v-if="image != null">
        <a class="btn-close" v-on:click="close()"></a>

        <div class="info-pane__header">
          <h1 class="info-pane__title" v-if="image.year">{{ image.address_street }}</h1>
          <h2 class="info-pane__subtitle">{{ image.location }}</h2>
        </div>

        <div class="archive-thumb" @click="showOlderImages" v-show="image.src_past">
          <div class="archive-thumb__image" :style="{'background-image': srcPastUrl}">
          </div>
        </div> 

        <div class="info-pane__col1">
            <div class="info-pane__photo-wrapper">
                <div class="badge-magnifier-plus"></div>
                <Photoswipe>
                  <img v-bind:src="image.src" v-bind:data-pswp-src="image.src" alt="" class="info-pane__photo" @load="imageLoaded">
                </Photoswipe>
                <svg ref="imageBorder">
                  <mask :id="'m-' + image.id" fill='#fff'>
                    <rect :id="'b-' + image.id" width='100%' height='100%'/>
                    <circle :id="'c-' + image.id" r='16' fill='#000'/>
                    <use :xlink:href="'#c-' + image.id" x='100%'/>
                    <use :xlink:href="'#c-' + image.id" y='100%'/>
                    <use :xlink:href="'#c-' + image.id" x='100%' y='100%'/>
                  </mask>
                  <use :xlink:href="'#b-' + image.id" :mask="'url(#m-' + image.id + ')'"/>
                </svg>
            </div>
        </div>
        <div class="info-pane__col2">
            <div class="item-info">
                <h2>Année de construction</h2>
                <p>{{ image.year_built || 'Inconnue' }}</p>
                <h2>Propriétaire</h2>
                <p>{{ image.building_owner || 'Inconnu' }}</p>
                <h2>Activité</h2>
                <p>{{ image.building_purpose_past || 'Inconnue' }}</p>
                <h2>Type de bâtiment</h2>
                <p>{{ image.building_type || 'Inconnu' }}</p>
                <h2>Aujourd’hui</h2>
                <p>{{ image.building_purpose_present || 'Inconnu' }}</p>
            </div>
        </div>
        <div class="info-pane__col3">
          <div class="history-wrapper" v-if="image.caption && image.caption != '<p>\n</p>'">
            <div class="history-wrapper__scroller">
              <div v-html="image.caption"></div>
            </div>
          </div>
        </div>
    </div>
    <div class="fond-panneau"></div>

</div>
</template>

<script>

import JQuery from 'jquery';
let $ = JQuery;
import _ from 'lodash';
import Vue from 'vue';
import Selectize from 'vue2-selectize';

import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes});

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

Vue.use(VueNotifications, {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
});

export default {
  name: 'GalleryDetail',
  props: {
    msg: String
  },
  components: {
    'selectize': Selectize
  },
  data: function () {

    return {
      image: null,
      processing: false
    };

  },

  computed: {

    srcPastUrl: function() {
      return (this.image.src_past)? "url('" + _.first(this.image.src_past) + "')" : null;
    }
  },

  mounted: function () {
    //
  },

  methods: {

    setData: function (image) {
      this.image = image;
    },

    close: function () {
      this.image = null;
    },

    showOlderImages: function () {

      var items = [];
      this.image.src_past


      this.$Pswp.open({
        items: _.map(this.image.src_past, function(image){
          return {
            src: image
          };
        })
      });
    },

    imageLoaded: function (event) {
      event.path[1].classList.add('is--loaded');
    }

  },

  notifications: {
  }

} 
</script>   

<style lang="scss">

$almost-black: #291D20;
$burnt-sienna-orange: #ef6565;
$grey: #e6e6e6;

.title {
  color: #d42c2c;
  font-size: 44px;
}

.btn-close {
  position: absolute;
  top: 50px;
  left: 0px;
  height: 85px;
  width: 85px;
  z-index: 101;

  background-image: url('../assets/close-icon.svg');
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.pswp__top-bar,
.pswp__button--fs,
.pswp__button--close {
  display: none!important;
}

.item-info__title {
  margin-top: 47px;
  color: #000;
  font-size: 35px;
  line-height: 42px;
  font-weight: 600;
}

.info-pane__header {

  position: absolute;
  left: 320px;
  top: 60px;
  max-width: 900px;
  z-index: 101;

  .info-pane__title {
    color: $burnt-sienna-orange;
    font-family: 'WalsheimBold';
    font-size: 85px;
    line-height: 90px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .info-pane__subtitle {
    color: $burnt-sienna-orange;
    font-family: 'WalsheimMedium';
    font-size: 35px;
    line-height: 43px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}

.info-pane__photo {
  display: block;
  max-height: 664px;
  max-width: 100%;
  margin: auto;
}

.form {
  margin-top: 67px;
}

.marges-page {
  position: relative;
  height: 100vh;
  padding-left: 50px;
  padding-right: 70px; // 54
  z-index: 101;

  * {
    box-sizing: border-box;
  }
}

.fond-panneau {
  position: absolute;
  left: 208px;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  display: flex;
  background-image: url('../assets/pane-bg.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.panneau {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding-left: 0px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  z-index: 2;
}

.info-pane__col1,
.info-pane__col2,
.info-pane__col3 {
  height: 100vh;
  overflow-y: auto;
}

.info-pane__col1 {
  position: relative;
  width: 40%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 316px;
  padding-right: 39px;
}

.info-pane__col2 {
  width: 25%;
  padding-top: 303px;
  padding-left: 50px;
}

.info-pane__col3 {
  width: 33%;
  margin-left: 0px;
  padding-bottom: 2px;
  padding-top: 230px;
  padding-left: 38px;
}

.form-label {
  display: inline-block;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: #000;
  font-size: 23px;
  line-height: 27px;
  font-weight: 500;
  text-transform: none;
}

.primary-btn {
  display: inline-block;
  margin-top: 42px;
  padding: 15px;
  background-color: #000;
  font-size: 25px;
  font-weight: 900;
}

.item-info__description {
  margin-top: 30px;
  margin-bottom: 46px;
  color: #000;
  font-size: 23px;
  line-height: 27px;
  font-weight: 500;
  text-align: left;
}

.form-textarea {
  height: 146px;
  margin-bottom: 0px;
  border-color: transparent;
  background-color: #ededed;
}

.form-text[type='checkbox'] {
  display: inline-block;
  width: 30px;
  margin-right: 1em;
  transform: translateY(25%);
}

.info-pane__title-wrapper {
  position: relative;
  margin-right: 0px;
  padding: 0px 10px 0px 193px;
  background-color: transparent;
}

form input,
form .selectize-control {
  display: block;
  width: 100%;
  margin-bottom: 28px;
}

.selectize-input {
  background-color: #ededed;
  border: none;
  height: 35px;
}

form input[type='submit'] {
  color: white;
  width: auto;
  font-family: inherit;
}

form input[disabled='disabled'] {
  opacity: 0.5;
}

.form-text {
  height: 35px;
  border-style: none;
  border-color: transparent;
  background-color: #ededed;
  font-family: 'KranaFatB', sans-serif;
  font-size: 16px;
  padding: 0 12px;
}

.item-info {
  position: relative;
  overflow: auto;
  max-height: 700px;
  color: $almost-black;

  h2 {
    font-family: 'WalsheimBold';
    font-size: 25px;
    color: $burnt-sienna-orange;
    text-decoration: underline;
    margin-top: 0;
    margin-bottom: 3px;
  }

  p {
    font-family: 'WalsheimMedium';
    font-size: 20px;
    line-height: 29px;
    margin: 0;

    & + h2 {
      margin-top: 45px;
    }
  }
}

.item-share__title {
  margin-top: 0;
  margin-bottom: 65px;
  color: #000;
  font-size: 35px;
  line-height: 44px;
  font-weight: 900;
}

.info-pane__photo-wrapper {
  position: relative;
  display: block;
  padding: 21px;

  svg {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; 
    height: 100%;
    z-index: 0;
  }

  use {
    fill: #f7f7f7;
  }

  img {
    border: 1px solid $grey;
  }

  .pswipe-gallery.is--loaded + svg {
    display: block;
  }

  .pswipe-gallery {
    position: relative;
    z-index: 1;
  }
}

.badge-magnifier-plus {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 80px;
  width: 80px;
  transform: translate(-50%, -50%);
  background-image: url('../assets/magnifier-icon--plus.svg');
  pointer-events: none;
  z-index: 2;
}

.history-wrapper {
  height: 762px;
  max-width: 508px;
  float: right;
  background-image: url('../assets/history-bg.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding: 184px 45px 48px 45px;

  .history-wrapper__scroller {
    max-height: 100%;
    overflow-y: auto;
  }

  p {
    font-family: 'WalsheimRegular';
    font-size: 20px;
    line-height: 29px;
    color: $almost-black;
    margin-top: 0;
    margin-bottom: 29px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  mark {
    font-family: 'WalsheimBold';
    background: none;
    position: relative;
    &:after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 23px;
      background-image: url('../assets/voc-icon.svg');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      margin: 0 5px -5px 5px;
    }
  }
}

.archive-thumb {
  width: 278px;
  height: 180px;
  background-image: url('../assets/archive-thumb-ribbon.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 15px;
  padding-bottom: 17px;
  text-align: center;
  position: absolute;
  bottom: 57px;
  left: 0;
  z-index: 101;

  .archive-thumb__image {
    display: inline-block;
    height: 110px;
    width: 110px;
    background-size: cover;
    border: 4px solid white;
    margin-left: -16px;
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      top: 50%;
      height: 50px;
      width: 50px;
      transform: translate(-50%, -50%);
      background-image: url('../assets/magnifier-icon.svg');
      pointer-events: none;
      z-index: 2;
    }
  }
}

</style>